import { render, staticRenderFns } from "./OrderCustomerDetail.vue?vue&type=template&id=74e99e6a&scoped=true&"
import script from "./OrderCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e99e6a",
  null
  
)

export default component.exports